import { render, staticRenderFns } from "./DynamicBlock.vue?vue&type=template&id=1cb45612"
import script from "./DynamicBlock.vue?vue&type=script&lang=js"
export * from "./DynamicBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports